export const team = [
    {
        id: 1,
        icon: '/images/icons/react-label.png',
        members: [
            '/images/avatars/10.png',
            '/images/avatars/4.png',
            '/images/avatars/9.png',
            '/images/avatars/14.png',
        ],
        skills: [
            'REACT',
            'VUE.JS',
        ],
        title: 'توسعه دهندگان React',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون'
    },
    {
        id: 2,
        icon: '/images/icons/vue-label.png',
        members: [
            '/images/avatars/10.png',
            '/images/avatars/4.png',
            '/images/avatars/14.png',
        ],
        skills: [
            'توسعه دهنده'
        ],
        title: 'تیم توسعه Vue.js',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.'
    },
    {
        id: 3,
        icon: '/images/icons/xd-label.png',
        members: [
            '/images/avatars/9.png',
            '/images/avatars/14.png',
        ],
        skills: [
            'SKETCH',
            'XD'
        ],
        title: 'طراحان خلاق',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون'
    },
    {
        id: 4,
        icon: '/images/icons/support-label.png',
        members: [
            '/images/avatars/10.png',
            '/images/avatars/4.png',
            '/images/avatars/9.png',
        ],
        skills: [
            'ZENDESK'
        ],
        title: 'تیم پشتیبانی',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه'
    },
    {
        id: 5,
        icon: '/images/icons/twitter-label.png',
        members: [
            '/images/avatars/9.png',
            '/images/avatars/14.png',
        ],
        skills: [
            'توییتر',
            'ایمیل'
        ],
        title: 'بازاریابی دیجیتال',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون'
    },
    {
        id: 6,
        icon: '/images/icons/sketch-label.png',
        members: [
            '/images/avatars/10.png',
            '/images/avatars/4.png',
            '/images/avatars/9.png',
            '/images/avatars/14.png',
        ],
        skills: [
            'HUBILO'
        ],
        title: 'رویداد',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک و متون بلکه روزنامه و مجله در ستون'
    },
    {
        id: 7,
        icon: '/images/icons/figma-label.png',
        members: [
            '/images/avatars/9.png',
            '/images/avatars/14.png',
        ],
        skills: [
            'فتوشاپ',
            'فیگما'
        ],
        title: 'منابع فیگما',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون'
    },
    {
        id: 8,
        icon: '/images/icons/html-label.png',
        members: [
            '/images/avatars/10.png',
            '/images/avatars/4.png',
            '/images/avatars/9.png',
        ],
        skills: [
            'CSS',
            'HTML'
        ],
        title: 'مبتدیان',
        caption: 'لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است.'
    },
]